import { render, staticRenderFns } from "./Popularize.vue?vue&type=template&id=5ac52659&scoped=true&"
import script from "./Popularize.vue?vue&type=script&lang=js&"
export * from "./Popularize.vue?vue&type=script&lang=js&"
import style0 from "./Popularize.vue?vue&type=style&index=0&id=5ac52659&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ac52659",
  null
  
)

export default component.exports